module.exports = __webpack_public_path__ + "img/logo.a142b47.png";